import React, { useEffect, useState } from "react";
import axios from "axios";
import InputOption from "../../../component/InputOption/InputOption";


const AccountComponent = ({ label, onAccountUpdated, onTotalCreditUpdated, onTotalDebitUpdated, items }) => {
    const [optionAccount, setOptionAccount] = useState([]);

    const [rows, setRows] = useState([
        {
            account: "",
            description: "",
            debit: 0,
            credit: 0,
        },
    ]);

    const [error, setError] = useState(null);

    const handleChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([
            ...rows,
            {
                account: "",
                description: "",
                debit: 0,
                credit: 0
            },
        ]);
    };

    const removeRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
    };

    const calculateTotalCredit = (row) => {                
        return row.credit;
    };

    const calculateTotalDebit = (row) => {
        return row.debit;
    };

    const calculateSubtotal = (type) => {
        if (type == 'credit') {
            return rows.reduce((total, row) => total + calculateTotalCredit(row), 0);            
        } else if (type == 'debit') {
            return rows.reduce((total, row) => total + calculateTotalDebit(row), 0);            
        }
        return 0;
    }

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_ACCOUNT_EXPENSES = "api/erpppsu/account/expense";

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            // setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_ACCOUNT_EXPENSES}`).then((data) => {
            setOptionAccount(data);
        });
    }, []);

    useEffect(() => {
        onAccountUpdated(rows);

        onTotalCreditUpdated(calculateSubtotal('credit'));
        onTotalDebitUpdated(calculateSubtotal('debit'));
    }, [rows])

    useEffect(() => {
        if (items && items.length > 0) {
            const formattedRows = items.map((item) => ({
                account: item.account,
                description: item.description,
                debit: parseFloat(item.debit),
                credit: parseFloat(item.credit)
            }));

            setRows(formattedRows);
        }
    }, [items]);

    return (
        <div className="relative max-w-full p-4 overflow-x-auto">
            <div className="max-w-full overflow-x-auto">
                <table className="w-full border-collapse border border-gray-200">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="w-1/5 min-w-40 p-2 border border-gray-200">{label}</th>
                            <th className="w-1/5 min-w-40 p-2 border border-gray-200">Deskripsi</th>
                            <th className="w-1/5 min-w-40 p-2 border border-gray-200">Debit</th>
                            <th className="w-1/5 min-w-40 p-2 border border-gray-200">Kredit</th>
                            <th className="w-1/5 p-2 border border-gray-200"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td className="p-2 border border-gray-200">
                                    <InputOption
                                        label="Pilih Akun"
                                        data={optionAccount}
                                        placeholder="Ketik disini"
                                        defaultValue={row?.account}
                                        onChange={(value) => {
                                            handleChange(index, "account", value)
                                        }}
                                        returnKey="code"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <input
                                        type="text"
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.description}
                                        onChange={(e) =>
                                            handleChange(index, "description", e.target.value)
                                        }
                                        placeholder="Masukkan keterangan"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <input
                                        type="number"
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.debit}
                                        onChange={(e) =>
                                            handleChange(index, "debit", parseFloat(e.target.value) || 0)
                                        }
                                        min="0"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <input
                                        type="number"
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.credit}
                                        onChange={(e) =>
                                            handleChange(index, "credit", parseFloat(e.target.value) || 0)
                                        }
                                        min="0"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200 text-center">
                                    <button
                                        onClick={() => removeRow(index)}
                                        className="text-red-500 hover:text-red-700"
                                    >
                                        &times;
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <button
                type="button"
                onClick={addRow}
                className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
                Tambah Data
            </button>
        </div>
    );
};

export default AccountComponent;
